module.exports = __webpack_public_path__ + "static/media/home.41007ba9.svg";